var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailResendLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88962 0.592773C1.20391 0.592773 0.642868 1.15381 0.642868 1.83953V9.32005C0.642868 10.0058 1.20391 10.5668 1.88962 10.5668H8.43508C8.26552 10.1704 8.1603 9.74957 8.12339 9.32005H1.88962V3.08628L6.87663 6.20316L11.8636 3.08628V4.95641C11.9675 4.9527 12.0715 4.9527 12.1753 4.95641C12.4903 4.95734 12.8041 4.995 13.1104 5.06862V1.83953C13.1104 1.15381 12.5494 0.592773 11.8636 0.592773H1.88962ZM1.88962 1.83953H11.8636L6.87663 4.95641L1.88962 1.83953ZM11.8636 5.57979L10.4611 6.98238L11.8636 8.38498V7.44992C12.277 7.44992 12.6734 7.61411 12.9656 7.90637C13.2579 8.19864 13.4221 8.59503 13.4221 9.00836C13.4221 9.25771 13.366 9.49459 13.26 9.70654L13.9395 10.386C14.2013 9.99329 14.3572 9.51953 14.3572 9.00836C14.3572 7.6307 13.2413 6.51485 11.8636 6.51485V5.57979ZM9.7878 7.6307C9.52598 8.02342 9.37014 8.49719 9.37014 9.00836C9.37014 10.386 10.486 11.5019 11.8636 11.5019V12.4369L13.2662 11.0343L11.8636 9.63173V10.5668C11.4503 10.5668 11.0539 10.4026 10.7617 10.1103C10.4694 9.81808 10.3052 9.42168 10.3052 9.00836C10.3052 8.75901 10.3613 8.52212 10.4673 8.31018L9.7878 7.6307Z",
    fill: "#887952"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailResendLink);
export default __webpack_public_path__ + "static/media/email-resend-link.463bd2ca84e9dcdbdbfc555bd542e5a2.svg";
export { ForwardRef as ReactComponent };